import React, { useEffect, useState } from "react";

import {
  Box,
  Flex,
  Select,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Link,
  Button,
  Img,
  AspectRatio,
  useToast,
  Opti,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import DeleteButton from "components/AlertDialogButton/DeleteButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

//Backend API
import { getBanners, deleteBanner } from "service/banner.service";

//Constants
import { BANNER_TYPES } from "constants";
import { TEXT_DIALOG, REQUEST_TEXT_STATUS } from "constants/bannersText";
import { BiSkipNext, BiSkipNextCircle, BiSkipPrevious } from "react-icons/bi";

export default function Banner() {
  // Variables
  const history = useHistory();
  const toast = useToast();

  // Backend API - use getBanner
  const [useBannerList, setUseBannerList] = useState([]);
  const [bannersPage, setBannersPage] = useState(1);
  const [bannersType, setBannersType] = useState("");
  const [bannersTotal, setBannersTotal] = useState(0);
  const [bannerDeletion, setBannerDeletion] = useState(false);

  const getQueryResult = async () => {
    const updateQueryResult = await getBanners(bannersPage, bannersType); // params: page="1", type="root"

    setBannersTotal(updateQueryResult.to ?? 0);
    setUseBannerList([...updateQueryResult.data]);
  };

  // Functions to render update
  useEffect(() => {
    getQueryResult();
    setBannerDeletion(false);
  }, [bannersPage, bannersType, bannerDeletion]);
  // (END) Backend API - use getBanner()

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <Spacer />

        <CardHeader p="6px 0px 22px 0px">
          <Box w="full" p="2">
            <Text fontSize="lg" color="#fff" fontWeight="bold">
              <Button
                bg="#042D0E"
                py="4px"
                px="20px"
                mr="50px"
                borderColor="#31B551"
                borderWidth="2px"
                rounded="md"
                _hover={{ bg: "#034414", borderColor: "white" }}
                onClick={() => {
                  history.push({
                    pathname: "/admin/banner/form/create",
                  });
                }}
              >
                New Banner
              </Button>
              Page:
              {/* Page navigation starts here */}
              <Button
                bg="#380433"
                py="4px"
                px="8px"
                mx="25px"
                borderColor="#9E1291"
                borderWidth="2px"
                rounded="md"
                _hover={{ bg: "#5C0954", borderColor: "white" }}
                onClick={() => {
                  setBannersPage(bannersPage - 1);
                }}
                isDisabled={bannersPage <= 1}
              >
                <BiSkipPrevious size="30px" />
              </Button>
              {/* Current Page */}
              {bannersPage}
              <Button
                bg="#380433"
                py="4px"
                px="8px"
                mx="25px"
                borderColor="#9E1291"
                borderWidth="2px"
                rounded="md"
                _hover={{ bg: "#5C0954", borderColor: "white" }}
                onClick={() => {
                  setBannersPage(bannersPage + 1);
                }}
                isDisabled={bannersTotal < 15}
              >
                <BiSkipNext size="30px" />
              </Button>
              Total Banners: {bannersTotal}
            </Text>
          </Box>
        </CardHeader>

        <CardBody>
          <TableContainer
            overscroll="auto"
            maxH="2xl"
            overflowY="scroll"
            position="relative"
            w="full"
          >
            <Table varient="simple" color="#fff">
              <Thead
                position="sticky"
                top="0"
                zIndex="sticky"
                bg="gray.900"
                color="whiteAlpha.900"
              >
                <Tr my=".8rem" ps="0px" color="gray.400">
                  <Th
                    ps="0px"
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    NAME
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    ID
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    LINK
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    <Select
                      _placeholder={{ color: "black" }}
                      fontSize={"xs"}
                      fontWeight={"bold"}
                      textTransform={"uppercase"}
                      onChange={(e) => {
                        setBannersType(e.target.value);
                      }}
                    >
                      <option
                        value={""}
                        style={{ textColor: "white", backgroundColor: "black" }}
                        defaultValue={""}
                      >
                        BANNER TYPE
                      </option>
                      {Object.keys(BANNER_TYPES).map((key) => (
                        <option
                          key={key}
                          value={key}
                          style={{ textColor: "white", backgroundColor: "black" }}
                        >
                          {key}
                        </option>
                      ))}
                    </Select>
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    ACTION
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {
                  /* Display Fetched Banner Data */
                  useBannerList.map((banner, index, arr) => {
                    return (
                      <Tr key={index}>
                        <Td>{banner?.name}</Td>
                        <Td>{banner?.id}</Td>
                        <Td>
                          <Link href={banner?.files[0]?.file_url} target="_blank">
                            <AspectRatio ratio={17 / 11}>
                              <Img
                                src={banner?.files[0]?.file_url}
                                objectFit="cover"
                                alt={`${banner?.files[0]?.name}`}
                                fallbacksrc="https://via.placeholder.com/150"
                              />
                            </AspectRatio>
                          </Link>
                        </Td>
                        <Td>{banner?.type}</Td>
                        <Td>
                          <Button
                            bg="#032135"
                            py="4px"
                            px="8px"
                            mr="3px"
                            borderColor="#0E6CAA"
                            borderWidth="2px"
                            rounded="md"
                            _hover={{ bg: "#093C5E", borderColor: "white" }}
                            onClick={() => {
                              history.push({
                                pathname: "/admin/banner/form/update",
                                state: banner,
                              });
                            }}
                          >
                            Edit
                          </Button>
                          <DeleteButton
                            buttonText={"Delete"}
                            dialog={TEXT_DIALOG["delete"]}
                            textTransform="normal"
                            buttonColor="red"
                            func={async () => {
                              try {
                                const res = await deleteBanner(banner.id);
                                if (res) {
                                  toast(REQUEST_TEXT_STATUS["delete"].success);
                                  setBannerDeletion(true);
                                }
                              } catch (error) {
                                toast(REQUEST_TEXT_STATUS["delete"].error);
                              }
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  }) /** End of Display Fetched Banner Data */
                }
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
}
